import React from 'react';
import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Box component="footer" sx={{ mt: 'auto', py: 3, borderTop: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
      <Container maxWidth="lg" sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} DataHive. All rights reserved.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <MuiLink component="button" type="button" variant="body2" onClick={() => navigate('/terms')} sx={{ textTransform: 'none' }}>
            Terms of Service
          </MuiLink>
          <MuiLink component="button" type="button" variant="body2" onClick={() => navigate('/privacy')} sx={{ textTransform: 'none' }}>
            Privacy Policy
          </MuiLink>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
